// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3G_Uf","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1WD8f","obliqueLine":"membershipbadge_obliqueLine__BKZBN"};